import HttpService from "./htttp.service";

class UsersService {
  getUserByEmail = async (email) => {
    const endpoint = "users/email/" + email;
    return await HttpService.get(endpoint);
  };

  getUser = async (payload) => {
    const endpoint = "users/single";
    return await HttpService.get(endpoint, payload);
  };

  getUsers = async (payload, callback, cancelToken) => {
    const endpoint = "users";
    if (callback) {
      callback(await HttpService.get(endpoint, payload, cancelToken));
    } else {
      return await HttpService.get(endpoint, payload, cancelToken);
    }
  };

  createUser = async (query, payload) => {
    const endpoint = "users";
    return await HttpService.post(endpoint, payload, query);
  };

  updateUser = async (id, query, payload) => {
    const endpoint = "users/" + id;
    return await HttpService.put(endpoint, payload, query);
  };

  updateUserTFA = async (id, query, payload) => {
    const endpoint = "users/" + id + "/2fa-update";
    return await HttpService.put(endpoint, payload, query);
  };

  generateQrCodeTFA = async (query, payload) => {
    const endpoint = "users/2fa/generate-qr";
    return await HttpService.post(endpoint);
  };

  disableTFA = async (query, payload) => {
    const endpoint = "users/2fa/disable";
    return await HttpService.post(endpoint);
  };

  verifyUserTFA = async (payload) => {
    const endpoint = "users/2fa/verify";
    return await HttpService.put(endpoint, payload);
  };

  verifyOTP = async (query, payload) => {
    const endpoint = "2fa-verify-otp";
    return await HttpService.post(endpoint, payload, query);
  };

  deleteUser = async (id, query) => {
    const endpoint = "users/" + id;
    return await HttpService.delete(endpoint, query);
  };
}

export default new UsersService();
